
import { Base64 } from "js-base64"
import { Dialog, Button, Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import addres from "./address"
import delivery from "./delivery"
import delivery2 from "./delivery2"
import pickup from "./pickup"
import offlinePayment from "./offlinePayment.vue"
import paymentMethods from "./payment-methods"
import summar from "./summary"
import deliveryInfo from "./deliveryInfo.vue"
import info from "./info"
import coupons from "./coupons"
import tipsDialog from "./tips-dialog"
import { calcPromotion } from "@/api/middle.js"
import { goCheckoutV2, orderSubmit } from "@/api/checkout.js"
import { showGlobalMessage, getDeliveryMethod, base64Decode, clientKeyMap } from "@/utils/utils"
import { trackAddPaymentInfo } from "@/utils/track"
import paymentMixin from "@/mixins/payment"

export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    drawerHeader,
    addres,
    delivery,
    summar,
    deliveryInfo,
    offlinePayment,
    info,
    coupons,
    tipsDialog,
    pickup,
    delivery2,
    paymentMethods
  },
  mixins: [paymentMixin],
  data() {
    return {
      centerDialogVisible: false,
      ageAlert: "",
      dialogVisible: false,
      loading: false,
      addrData: {},
      shipTimeItemList: [],
      wareInfo: {},
      bill: {},
      submit: {},
      toastInfos: {},
      couponReponse: {},
      checkoutParams: {},
      submitParams: {}, // 下单相关参数
      orderNo: "", // 订单号
      orderList: "",
      afterPayProOrderPrice: "", // 优惠后的金额
      promotionEnjoy: {},
      deliveryValue: "clickCollect",
      shipTimeInfo: null,
      curSelStore: {}, // 当前门店信息
      timeIsActive: false,
      storeInfo: {},
      yuuId: "",
      deliveryList: [], // 配送模式下，提交结算的商品数组
      offlinePaymentFlag: 0, // 0: 默认, 1: 货到付款
      offlinePaymentMethodList: [] // 货到付款方式列表
    }
  },
  computed: {
    submitCanClick() {
      return !!(
        this.paymentMethod &&
        (this.deliveryValue === "homeDelivery"
          ? this.submitParams.shipmentTime && this.submitParams.shipmentDate
          : true)
      )
    },
    errorTipsText() {
      // 先看是否有选择配送时间
      // const shipTime1 = res.shipTimeItemList.find(v => v.selected)
      // const shipTime2 = shipTime1 && shipTime1.timeList_ ? shipTime1.timeList_.find(v => v.selected) : null
      if (!this.timeIsActive && this.deliveryValue === "homeDelivery") {
        return this.$t("checkout.noTimeTips")
      }
      // 再看是否有选择的支付方式
      if (!this.paymentMethod) {
        return this.$t("checkout.noCardTips")
      }
      return ""
    }
  },
  async created() {
    window.scrollTo(0, 0)
    this.checkoutParams = JSON.parse(Base64.decode(this.$route.query.params))
    if (this.checkoutParams.shipmentType === 1) {
      this.centerDialogVisible = true
    } else {
      this.centerDialogVisible = false
    }
    this.offlinePaymentFlag = this.checkoutParams?.offlinePaymentFlag || 0
    this.deliveryValue = getDeliveryMethod()
    this.curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
    this.getYuuId()
    await this.initPaymentSDK({
      merchantId: this.checkoutParams.venderId
    })
    this.initGetCheckout()
  },
  methods: {
    initGetCheckout() {
      if (this.paymentMethod.signNum) {
        this.checkoutParams = {
          ...this.checkoutParams,
          chosenSignNum: this.paymentMethod.signNum
        }
      }
      this.getCheckout()
    },
    cancel() {
      this.$navigation.replace({
        path: "/cart"
      })
    },
    getYuuId() {
      const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""
      this.yuuId = accountInfo && accountInfo.yuuId
    },
    handleDialogCancel() {
      this.dialogVisible = false
    },
    handleDialogConfirm() {
      this.dialogVisible = false
      this.handleSubmit()
    },
    getParamsFromAddr(val) {
      // encodeURIComponent encodeURIComponent(val.addressDetail), s
      if (!val) return
      if (this.checkoutParams.shipmentType === 1) {
        this.submitParams = {
          ...this.submitParams,
          addressId: val.id,
          addressDetail: val.addressDetail,
          addressName: val.addressName,
          areaName1: val.areaName1,
          areaName2: val.areaName2,
          areaName3: val.areaName3,
          latitude: val.latitude,
          longitude: val.longitude,
          consignee: localStorage.getItem("checkout_name") || encodeURIComponent(val.consignee),
          mobilPhone: localStorage.getItem("checkout_phone") || val.mobilPhone,
          remarks: val.remarks || ""
        }
      } else {
        this.submitParams = {
          ...this.submitParams,
          addressName: this.curSelStore.address,
          latitude: this.curSelStore.lat,
          longitude: this.curSelStore.lng,
          consignee: localStorage.getItem("checkout_name") || this.checkoutParams.userName || "",
          mobilPhone: localStorage.getItem("checkout_phone") || this.checkoutParams.phone || "",
          remarks: ""
        }
      }
    },
    getParamsFromTime(timeList) {
      const item = timeList.find(v => v.selected)
      const shipmentDate = item ? item.date : null
      const _item = item ? item.timeList_.find(v => v.selected) : null
      const shipmentTime = _item ? _item.value : null
      this.submitParams = {
        ...this.submitParams,
        shipmentTime,
        shipmentDate
      }
    },
    getParamsFromBill(val) {
      this.submitParams = {
        ...this.submitParams,
        afterPromotionPrice: val.afterPromotionPrice,
        afterPayProOrderPrice: val.subtotalPrice
      }
    },
    getParamsFromCoupon(val) {
      const item = val.valid
      if (item) {
        const couponCodeList = item.filter(v => v.checked).map(_v => _v.couponCode)
        this.submitParams = {
          ...this.submitParams,
          couponCodeList
        }
      }
    },
    handleAddrChanged() {
      this.getCheckout()
    },
    handleAddrPickChanged(val) {
      this.submitParams = {
        ...this.submitParams,
        email: val.email,
        consignee: encodeURIComponent(val.name),
        mobilPhone: val.code + " " + val.num
      }
    },
    handleInsChanged(val) {
      this.submitParams.remarks = val
    },
    handleTimeChanged(val) {
      this.checkoutParams = {
        ...this.checkoutParams,
        ...val
      }
      this.getCheckout(true)
    },
    handleCouponOpend() {
      // this.getCheckout();
    },
    handleCouponChanged(val) {
      this.checkoutParams = {
        ...this.checkoutParams,
        ...val,
        needHangUp: false
      }
      this.getCheckout()
    },
    handlePayChanged(val) {
      this.checkoutParams = {
        ...this.checkoutParams,
        chosenSignNum: val.signNum || null
      }
      this.getCheckout()
      this.paymentMethod = val
    },
    handlePaymentClose() {
      this.paymentVisible = false
      if (this.orderNo) {
        this.handlePayFail()
      }
    },
    submitTime(storeWareVOList) {
      // 提交的时候再次进行数据格式化，使数据统一，调用接口的时候方便处理
      this.deliveryList = storeWareVOList.map(val => ({
        ...val,
        skuId: val.sku,
        checkedPickUpStartTime: val.checkedPickUpStartTime,
        checkedPickUpEndTime: val.checkedPickUpEndTime,
        wareType: val.wareType
      }))
    },
    // 结账时提交
    async toOrder(params = {}) {
      if (this.deliveryValue === "clickCollect") {
        // 自提
        params.pickUpStoreId = this.curSelStore.erpStoreId
        params.pickUpStoreSapId = this.curSelStore.sapId
        params.pickUpStoreName = this.curSelStore.name
      }
      // 配送模式校验this.orderItemTimes下的时间是否都选择了
      if (this.checkoutParams.shipmentType === 1) {
        if (!this.deliveryList.length) {
          this.$message({
            message: this.$t("checkout.paymentReminder"),
            type: "warning"
          })

          return
        }
        let flag = false
        for (let i = 0; i < this.deliveryList.length; i++) {
          if (!this.deliveryList[i].checkedPickUpStartTime) {
            flag = true
            this.$message({
              message: this.$t("checkout.paymentReminder"),
              type: "warning"
            })
            break // 立即退出循环
          }
        }
        if (flag) {
          return
        }
      }

      try {
        const { data: res } = await orderSubmit({
          param: {
            payVersion: 2,
            ...this.submitParams,
            ...params,
            reqTradeOrderCheckedStoreVOs: this.checkoutParams.checkedStores,
            tradeMode: this.checkoutParams.tradeMode,
            storeId: this.checkoutParams.masterStoreId,
            tradeCouponVOs: this.checkoutParams.tradeCouponVOs,
            addressDetail: this.checkoutParams.unitFloor,
            shipmentType: this.checkoutParams.shipmentType,
            offlinePaymentFlag: this.checkoutParams.offlinePaymentFlag || 0,
            ...(this.checkoutParams.shipmentType === 1 && {
              addressId: this.checkoutParams.addressId,
              tradeOrderItemContent: {
                preOrderTypeName: "PRE_ORDER_FRESH_FOOD",
                orderItemTimes: this.deliveryList.map(val => ({
                  skuId: val.sku,
                  pickUpStartTime: val.checkedPickUpStartTime,
                  pickUpEndTime: val.checkedPickUpEndTime,
                  wareType: val.wareType
                }))
              }
            }),
            latitude:
              this.checkoutParams.shipmentType === 1 ? this.checkoutParams.latitude : this.submitParams.latitude,
            longitude:
              this.checkoutParams.shipmentType === 1 ? this.checkoutParams.longitude : this.submitParams.longitude
          }
        })
        this.afterPayProOrderPrice = res.afterPayProOrderPrice
        this.orderNo = res.orderId
        if (res.orderList && res.orderList.length) {
          this.orderList = res.orderList.map(v => v.orderId).join(",")
        }
        return true
      } catch (error) {
        // 下单失败
        if (error.code === "0065" || error.code === "0067" || error.code === "0069") {
          this.$messageBox
            .open({
              title: this.$t("checkout.note"),
              message: error.result,
              confirmText: this.$t("checkout.payAnyway"),
              cancelText: this.$t("checkout.backToCart"),
              showClose: false,
              disMaskClick: true,
              showConfirm: error.code !== "0065"
            })
            .then(async () => {
              const res = await this.toOrder({
                tipCode: error.code
              })
              if (res) {
                this.toPay()
              }
            })
            .catch(res => {
              this.$navigation.replace({
                path: "/cart"
              })
            })
        } else {
          this.$message.error(error.result)
        }
      }
    },
    handleSubmitWrapper() {
      if (this.orderNo) {
        this.handlePayFail()
        return
      }
      if (this.ageAlert) {
        this.dialogVisible = true
      } else {
        this.handleSubmit()
      }
    },
    handleOfflineSubmitWrapper() {
      if (this.ageAlert) {
        this.dialogVisible = true
      } else {
        this.handleSubmit()
      }
    },
    handleOfflineSubmitSuccess() {
      this.$navigation.replace({
        path: "/offline_payment_checkout",
        query: {
          orderNo: this.orderNo,
          orderList: this.orderList
        }
      })
    },
    async handleSubmit() {
      if (!this.submitParams.consignee) {
        this.$message({
          message: this.$t("address.pleaseEnterName"),
          type: "warning"
        })
        return
      }
      this.loading = true
      try {
        const res = await this.toOrder()
        if (res) {
          if (this.offlinePaymentFlag === 1) {
            this.handleOfflineSubmitSuccess()
            return
          }
          this.toPay()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async calcPromotion() {
      this.loading = true
      try {
        const res = await calcPromotion({
          orderId: this.orderNo,
          paymentMethod: this.paymentMethod.paymentMethodId,
          X_Merchant_Id: this.checkoutParams.venderId,
          X_Client_Key: clientKeyMap[this.checkoutParams.venderId]
        })
        return res.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    getPromotionEnjoy(promotionEnjoy) {
      const commData = JSON.parse(localStorage.getItem("commData"))
      let res = {}
      if (promotionEnjoy && commData && commData.comm) {
        const venderId = commData.comm.venderId
        res = promotionEnjoy.find(v => v.venderId === venderId) || {}
      }
      return res
    },
    genTempId() {
      return "temp-" + Math.random().toString(36).substr(2, 9)
    },
    async getCheckout(timeIsActive) {
      this.loading = true
      try {
        const { data: res } = await goCheckoutV2({
          param: {
            // addressId: this.addressId,
            // needHangUp: false,
            ...this.checkoutParams,
            payVersion: 2,
            pickUpStoreId: this.curSelStore.erpStoreId
          }
        })
        if (res && res.addrList) {
          this.payMethodsPromo = res.payMethods
          this.salePrice = this.getPriceFromPromoList()
          this.addrData = res.addrList.find(v => v.checked)
          this.shipTimeItemList = res?.shipTimeItemList
          this.wareInfo = res.wareInfoV2
          // 初始化所有 pickUpTimes 的 checked 字段为 false
          this.deliveryList = (res.wareInfoV2.wares || []).map(ware => {
            const pickUpTimes = (ware.pickUpTimes || []).map(time => ({
              ...time,
              id: time.id || this.genTempId(), // 设置唯一id值
              checked: !!time.checked
            }))
            return {
              ...ware,
              checkedPickUpStartTime: ware.canChangeTime === 0 ? pickUpTimes[0].pickUpStartTime : "",
              checkedPickUpEndTime: ware.canChangeTime === 0 ? pickUpTimes[0].pickUpEndTime : "",
              pickUpStartTimeDisplay: ware.canChangeTime === 0 ? pickUpTimes[0].pickUpStartTimeDisplay : "",
              pickUpTimes
            }
          })
          this.offlinePaymentFlag = res?.offlinePaymentFlag || 0
          this.offlinePaymentMethodList = res?.offlinePaymentMethod
          this.bill = res.bill
          this.submit = res.submit
          this.toastInfos = res.toastInfos
          this.couponReponse = {
            ...res.couponReponse,
            useInstructionsTitle: res.useInstructionsTitle,
            useManual: res.useManual,
            afterPromotionPrice: res.bill.afterPromotionPrice,
            consignId: this.checkoutParams.addressId
          }
          await this.getParamsFromAddr(this.addrData)
          if (timeIsActive) {
            this.timeIsActive = timeIsActive
            this.getParamsFromTime(res.shipTimeItemList)
          }
          this.getParamsFromBill(res.bill)
          this.getParamsFromCoupon(res.couponReponse)

          this.submitParams.wareTotalNum = res.wareInfoV2.totalCount
          this.submitParams.email = res.addrList[0].email
          this.promotionEnjoy = this.getPromotionEnjoy(res.promotionEnjoy)
          this.ageAlert = res.ageAlert
          this.shipTimeInfo = res.shipTimeInfo
          if (res.toast && res.toast.length) {
            res.toast.forEach(v => {
              showGlobalMessage({
                message: v,
                gap: 150,
                iconClass: "messageWarning"
              })
            })
          }
          const storeWareVOList = res.wareInfoV2.storeWareVOList
          if (storeWareVOList && storeWareVOList.length) {
            this.storeInfo = storeWareVOList[0]
          }
        }
      } catch (error) {
        this.$messageBox
          .open({
            title: this.$t("checkout.note"),
            message: error.result || error.message,
            confirmText: this.$t("checkout.backToCart"),
            showCancel: false,
            showClose: false,
            disMaskClick: true
          })
          .then(res => {
            this.$navigation.replace({
              path: "/cart"
            })
          })
          .catch(res => {})
      } finally {
        this.loading = false
      }
    },
    trackAddPaymentInfo() {
      trackAddPaymentInfo(this.wareInfo.wares, this.submitParams.couponCodeList, this.bill.subtotalPrice)
    },
    getChatNeedWareList() {
      if (!(this.wareInfo && this.wareInfo.wares && this.wareInfo.wares.length)) {
        return []
      }
      return this.wareInfo.wares.map(v => ({
        id: v.sku,
        name: v.name,
        brand: "",
        category: "",
        variant: "",
        quantity: v.count,
        price: v.promotionPrice
      }))
    }
  }
}
